export const LABEL_MANAGEMENT_PAGE_DAID = 'label-management-page';
export const LABEL_MANAGEMENT_CREATE_BUTTON_DAID = 'label-management-create-button';
export const LABEL_MANAGEMENT_TABLE_DAID = 'label-management-table';
export const LABEL_MANAGEMENT_VALUES_CELL_DAID = 'label-management-values-cell';
export const LABEL_MANAGEMENT_EDIT_ACTION_DAID = 'label-management-edit-action';
export const LABEL_MANAGEMENT_DELETE_ACTION_DAID = 'label-management-delete-action';
export const LABEL_MANAGEMENT_ACTIONS_MENU_DAID = 'label-management-actions-menu';
export const LABEL_MANAGEMENT_DELETE_CONFIRM_MODAL_DAID = 'label-management-delete-confirm-modal';
export const LABEL_MANAGEMENT_DELETE_CONFIRM_DAID = 'label-management-delete-confirm';
export const LABEL_MANAGEMENT_DELETE_CONFIRM_CANCEL_DAID = 'label-management-delete-confirm-cancel';
export const LABEL_MANAGEMENT_VALUES_MODAL_DAID = 'label-management-values-modal';

// Label Panel
export const LABEL_MANAGEMENT_PANEL_DAID = 'label-management-panel';
export const LABEL_MANAGEMENT_PANEL_DISPLAY_NAME_INPUT_DAID =
	'label-management-panel-display-name-input';
export const LABEL_MANAGEMENT_PANEL_DESCRIPTION_INPUT_DAID =
	'label-management-panel-description-input';
export const LABEL_MANAGEMENT_PANEL_KEY_DISPLAY_DAID = 'label-management-panel-key-display';
export const LABEL_MANAGEMENT_PANEL_KEY_INPUT_DAID = 'label-management-panel-key-input';
export const LABEL_MANAGEMENT_PANEL_ADD_VALUE_INPUT_DAID = 'label-management-panel-add-value-input';
export const LABEL_MANAGEMENT_PANEL_ADD_VALUE_BUTTON_DAID =
	'label-management-panel-add-value-button';
export const LABEL_MANAGEMENT_PANEL_UPLOAD_VALUES_BUTTON_DAID =
	'label-management-panel-upload-values-button';
export const LABEL_MANAGEMENT_PANEL_UPLOAD_VALUES_INPUT_DAID =
	'label-management-panel-upload-values-input';
export const LABEL_MANAGEMENT_PANEL_VALUES_TABLE_DAID = 'label-management-panel-values-table';
export const LABEL_MANAGEMENT_PANEL_DASHBOARD_TOGGLE_DAID =
	'label-management-panel-dashboard-toggle';
export const LABEL_MANAGEMENT_PANEL_REMOVE_VALUE_DAID = 'label-management-panel-remove-value';
export const LABEL_MANAGEMENT_PANEL_CSV_ERROR_BANNER_DAID =
	'label-management-panel-csv-error-banner';
export const LABEL_MANAGEMENT_PANEL_CSV_ERROR_DOWNLOAD_DAID =
	'label-management-panel-csv-error-download';
export const LABEL_MANAGEMENT_PANEL_CSV_ERROR_DISMISS_DAID =
	'label-management-panel-csv-error-dismiss';
export const LABEL_MANAGEMENT_PANEL_CANCEL_BUTTON_DAID = 'label-management-panel-cancel-button';
export const LABEL_MANAGEMENT_PANEL_SAVE_BUTTON_DAID = 'label-management-panel-save-button';
export const LABEL_MANAGEMENT_PANEL_DELETE_BUTTON_DAID = 'label-management-panel-delete-button';
